const allSchoolYearsData = [
    {
        type: "Dropdown",
        id: "appointed-date",
        content: [
            {
                label: "Select school year",
                value: "",
                disabled: true
            },
            // ADD 15 YEARS OF SCHOOL YEARS HERE
            {
                label: "2034–2035 school year",
                value: "09/05/2034"
            },
            {
                label: "2033–2034 school year",
                value: "09/06/2033"
            },
            {
                label: "2032–2033 school year",
                value: "09/07/2032"
            },
            {
                label: "2031–2032 school year",
                value: "09/02/2031"
            },
            {
                label: "2030–2031 school year",
                value: "09/03/2030"
            },
            {
                label: "2029–2030 school year",
                value: "09/04/2029"
            },
            {
                label: "2028–2029 school year",
                value: "09/05/2028"
            },
            {
                label: "2027–2028 school year",
                value: "09/07/2027"
            },
            {
                label: "2026–2027 school year",
                value: "09/08/2026"
            },
            {
                label: "2025–2026 school year",
                value: "09/04/2025"
            },
            {
                label: "2024–2025 school year",
                value: "09/03/2024"
            },
            {
                label: "2023–2024 school year",
                value: "09/05/2023"
            },
            {
                label: "2022–2023 school year",
                value: "09/06/2022"
            },
            {
                label: "2021–2022 school year",
                value: "09/09/2021"
            },
            {
                label: "2020–2021 school year",
                value: "09/08/2020"
            },
            {
                label: "2019–2020 school year",
                value: "09/03/2019"
            },
            {
                label: "2018–2019 school year",
                value: "09/04/2018"
            },
            {
                label: "2017–2018 school year",
                value: "09/05/2017"
            },
            {
                label: "2016–2017 school year",
                value: "09/06/2016"
            },
            {
                label: "2015–2016 school year",
                value: "09/08/2015"
            },
            {
                label: "2014–2015 school year",
                value: "09/02/2014"
            },
            {
                label: "2013–2014 school year",
                value: "09/03/2013"
            },
            {
                label: "2012–2013 school year",
                value: "09/04/2012"
            },
            {
                label: "2011–2012 school year",
                value: "09/06/2011"
            },
            {
                label: "2010–2011 school year",
                value: "09/07/2010"
            },
            {
                label: "2009–2010 school year",
                value: "09/08/2009"
            },
            {
                label: "2008–2009 school year",
                value: "08/28/2008"
            },
            {
                label: "2007–2008 school year",
                value: "08/31/2007"
            },
            {
                label: "2006–2007 school year",
                value: "08/31/2006"
            },
            {
                label: "2005–2006 school year",
                value: "09/06/2005"
            },
            {
                label: "2004–2005 school year",
                value: "09/07/2004"
            },
            {
                label: "2003–2004 school year",
                value: "09/02/2003"
            },
            {
                label: "Before 2003",
                value: "09/03/2002"
            }
        ]
    }
];

const currentDate = new Date();
const getAllYears = allSchoolYearsData[0].content;
const filterYears = getAllYears.filter(year => {
    if (year.value === "") {
        return true;
    }
    const schoolYearDate = new Date(year.value);
    return schoolYearDate <= currentDate;
});

export const schoolYearsData = [
    {
        type: "Dropdown",
        id: "appointed-date",
        content: filterYears
    }
]